import React from 'react';
import { IconProps } from './types';

const UnMuteCircledIcon: React.FC<IconProps> = props => {
  const {
    height = '24',
    width = '24',
    fillColor = 'var(--grayscale-3)',
    onClick = () => {}
  } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="14" cy="14" r="14" fill="#29A1A3" />
      <mask id="mask0_14977_207092" maskUnits="userSpaceOnUse" x="6" y="6" width="16" height="16">
        <rect x="6" y="6" width="16" height="16" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_14977_207092)">
        <path
          d="M17.8335 15.9666L16.8668 15C16.9668 14.8333 17.0529 14.6611 17.1251 14.4833C17.1974 14.3055 17.2501 14.1222 17.2835 13.9333C17.3168 13.7666 17.3974 13.625 17.5251 13.5083C17.6529 13.3916 17.7946 13.3333 17.9501 13.3333C18.1612 13.3333 18.3335 13.4055 18.4668 13.55C18.6001 13.6944 18.6501 13.8611 18.6168 14.05C18.5612 14.4055 18.4668 14.7416 18.3335 15.0583C18.2001 15.375 18.0335 15.6778 17.8335 15.9666ZM15.8668 13.9666L12.0001 10.1V9.33331C12.0001 8.77776 12.1946 8.30554 12.5835 7.91665C12.9724 7.52776 13.4446 7.33331 14.0001 7.33331C14.5557 7.33331 15.0279 7.52776 15.4168 7.91665C15.8057 8.30554 16.0001 8.77776 16.0001 9.33331V13.3333C16.0001 13.4555 15.9862 13.5666 15.9585 13.6666C15.9307 13.7666 15.9001 13.8666 15.8668 13.9666ZM18.7335 20.6L7.40013 9.26665C7.27791 9.14442 7.2168 8.98887 7.2168 8.79998C7.2168 8.61109 7.27791 8.45554 7.40013 8.33331C7.52235 8.21109 7.67791 8.14998 7.8668 8.14998C8.05569 8.14998 8.21124 8.21109 8.33346 8.33331L19.6668 19.6666C19.789 19.7889 19.8501 19.9444 19.8501 20.1333C19.8501 20.3222 19.789 20.4778 19.6668 20.6C19.5446 20.7222 19.389 20.7833 19.2001 20.7833C19.0112 20.7833 18.8557 20.7222 18.7335 20.6ZM13.3335 19.3333V17.9333C12.3001 17.8 11.4224 17.3722 10.7001 16.65C9.97791 15.9278 9.53902 15.0611 9.38346 14.05C9.35013 13.8611 9.40013 13.6944 9.53346 13.55C9.6668 13.4055 9.84457 13.3333 10.0668 13.3333C10.2224 13.3333 10.3612 13.3916 10.4835 13.5083C10.6057 13.625 10.6835 13.7666 10.7168 13.9333C10.8612 14.7111 11.239 15.3611 11.8501 15.8833C12.4612 16.4055 13.1779 16.6666 14.0001 16.6666C14.3779 16.6666 14.7362 16.6083 15.0751 16.4916C15.414 16.375 15.7224 16.2111 16.0001 16L16.9501 16.95C16.6279 17.2055 16.2751 17.4194 15.8918 17.5916C15.5085 17.7639 15.1001 17.8778 14.6668 17.9333V19.3333C14.6668 19.5222 14.6029 19.6805 14.4751 19.8083C14.3474 19.9361 14.189 20 14.0001 20C13.8112 20 13.6529 19.9361 13.5251 19.8083C13.3974 19.6805 13.3335 19.5222 13.3335 19.3333Z"
          fill="white"
        />
      </g>
    </svg>
  );
};

export default UnMuteCircledIcon;
